/* eslint-disable no-magic-numbers */
module.exports = {
    signinForm: {
        rules: [
            { name: 'required', fields: ['username', 'password'], required: true },
        ],
    },
    addNewCampaignFormMedia: {
        rules: [
            { name: 'required', fields: ['campaignName__company',
                'campaignName__product',
                'campaignName__indication',
                'campaignName__lineOfBusiness',
                'campaignName__finanicalYear',
                'placementName__channel',
                'placementName__mediaVendor',
                'placementName__engagement',
                'placementName__targetingType',
                'placementName__targetingTypeDetails',
                'placementName__audience',
                'placementName__buyType',
                'creativeName__contentName',
                'creativeName__brand',
                'creativeName__mediaContentType',
                'creativeName__agencyPartner',
                'creativeName__language'], required: true },
            { name: 'character type', fields: [
                'campaignName__additionalCampaignInfo',
                'placementName__targetingTypeDetails',
                'placementName__additionalPlacementInfo',
                'creativeName__contentName',
                'creativeName__creativeTalent',
                'creativeName__callToAction',
                'creativeName__additionalCreativeInfo',
                'creativeName__creativeContent'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
            { name: 'numbers only', fields: ['creativeName__videoDuration'], validators: [/^[0-9]*$/] },
            // eslint-disable-next-line no-useless-escape
            { name: 'website url', fields: ['websiteUrl__media'], validators: [/^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/] },
        ],
    },
    addNewCampaignFormSearch: {
        rules: [
            { name: 'required', fields: [
                'searchCampaignName__company',
                'searchCampaignName__product',
                'searchCampaignName__indication',
                'searchCampaignName__lineOfBusiness',
                'searchCampaignName__finanicalYear',
                'searchCampaignName__programName',
                'searchGroupName__searchType',
                'searchGroupName__searchDetail',
                'searchGroupName__language',
                'searchGroupName__audience',
                'searchGroupName__mediaVendor',
                'searchGroupName__channel'
            ], required: true },
            { name: 'character type', fields: [
                'searchCampaignName__additionalCampaignInfo',
                'searchGroupName__searchDetail',
                'searchGroupName__additionalPlacementInfo'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
            // eslint-disable-next-line no-useless-escape
            { name: 'website url', fields: ['websiteUrl__searchGroup'], validators: [/^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/] },
            { name: '50char', fields: ['searchGroupName__searchDetail'], validators: [/^([a-zA-Z0-9 _-]{1,50})(,[a-zA-Z0-9,\s_-]{1,50}){0,100}$/] },
        ],
    },
    addNewCampaignFormEmail: {
        rules: [
            { name: 'required', fields: [
                'campaignNameEmail__company',
                'campaignNameEmail__product',
                'campaignNameEmail__indication',
                'campaignNameEmail__lineOfBusiness',
                'campaignNameEmail__finanicalYear',
                'campaignNameEmail__programName',
                'emailName__channel',
                'emailName__engagement',
                'emailName__contentName',
                'emailName__brand',
                'emailName__language',
                'emailName__agencyPartner'
            ], required: true },
            { name: 'character type', fields: [
                'campaignNameEmail__additionalCampaignInfo',
                'emailName__contentName',
                'emailName__creativeTalent',
                'emailName__callToAction'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
            { name: 'date', fields: [
                'emailName__startDate'
            ], validators: [(v) => {
                const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(v);
                const date = new Date(v);
                return m && date != 'Invalid Date' && parseInt(m[1]) == date.getUTCFullYear() && parseInt(m[2]) == date.getUTCMonth() + 1 && parseInt(m[3]) == date.getUTCDate() && date.getUTCFullYear() >= 2020;
            }] },
            // eslint-disable-next-line no-useless-escape
            { name: 'website url', fields: ['websiteUrl__email'], validators: [/^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/] },
        ],
    },
    addPlacements: {
        rules: [
            { name: 'required', fields: [
                'placementName__channel',
                'placementName__mediaVendor',
                'placementName__engagement',
                'placementName__targetingType',
                'placementName__targetingTypeDetails',
                'placementName__audience',
                'placementName__buyType',
            ], required: true },
            { name: 'character type', fields: [
                'placementName__targetingTypeDetails',
                'placementName__additionalPlacementInfo',
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
        ],
    },
    addCreatives: {
        rules: [
            { name: 'required', fields: [
                'creativeName__contentName',
                'creativeName__brand',
                'creativeName__mediaContentType',
                'creativeName__agencyPartner',
            ], required: true },
            { name: 'character type', fields: [
                'creativeName__contentName',
                'creativeName__creativeTalent',
                'creativeName__callToAction',
                'creativeName__additionalCreativeInfo'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
            { name: 'numbers only', fields: ['creativeName__videoDuration'], validators: [/^[0-9]*$/] },
            // eslint-disable-next-line no-useless-escape
            { name: 'website url', fields: ['websiteUrl__media'], validators: [/^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/] },
        ],
    },
    addAdGroups: {
        rules: [
            { name: 'required', fields: [
                'searchGroupName__searchType',
                'searchGroupName__searchDetail',
                'searchGroupName__language',
                'searchGroupName__audience',
                'searchGroupName__mediaVendor',
                'searchGroupName__channel'
            ], required: true },
            { name: 'character type', fields: [
                'searchGroupName__searchDetail',
                'searchGroupName__additionalPlacementInfo'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
            // eslint-disable-next-line no-useless-escape
            { name: 'website url', fields: ['websiteUrl__searchGroup'], validators: [/^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/] },
            { name: '50char', fields: ['searchGroupName__searchDetail'], validators: [/^([a-zA-Z0-9 _-]{1,50})(,[a-zA-Z0-9,\s_-]{1,50}){0,100}$/] },
        ],
    },
    addEmailNames: {
        rules: [
            { name: 'required', fields: [
                'emailName__channel',
                'emailName__engagement',
                'emailName__contentName',
                'emailName__brand',
                'emailName__language',
                'emailName__agencyPartner'
            ], required: true },
            { name: 'character type', fields: [
                'emailName__contentName',
                'emailName__creativeConcept',
                'emailName__creativeTalent',
                'emailName__callToAction'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] },
            { name: 'date', fields: [
                'emailName__startDate'
            ], validators: [(v) => {
                const m = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(v);
                const date = new Date(v);
                return m && date != 'Invalid Date' && parseInt(m[1]) == date.getUTCFullYear() && parseInt(m[2]) == date.getUTCMonth() + 1 && parseInt(m[3]) == date.getUTCDate() && date.getUTCFullYear() >= 2020;
            }] },
            // eslint-disable-next-line no-useless-escape
            { name: 'website url', fields: ['websiteUrl__email'], validators: [/^(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/] },
        ],
    },
    addCampaign: {
        rules: [
            { name: 'required', fields: [
                'campaignName__company',
                'campaignName__product',
                'campaignName__indication',
                'campaignName__lineOfBusiness',
                'campaignName__finanicalYear'
            ], required: true },
            { name: 'character type', fields: [
                'campaignName__additionalCampaignInfo'
            ], validators: [/^[a-zA-Z0-9,\s_-]*$/] }
        ],
    },
};
